import GenerationStyles from './GenerationStyles'

export default GenerationStyles
